import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'

export interface DbPoolStatus {
  active: number
  idle: number
  waiting: number
  max: number
}

export interface ProcessWorkerStatus {
  workerId: string
  hostname: string
  hostPlatform?: string
  nodeVersion?: string
  updatedAt: string
  cpuPercent: number | null
  memoryRssMb: number
  memoryRssLimitMb: number | null
  memoryHeapMb: number
  memoryHeapLimitMb: number | null
  uptimeSec: number
  eventLoopLagP99Ms: number | null
  handlerRunning: number
  handlerQueued: number
  sqsConsumers: number
  dbPool: DbPoolStatus
}

export interface ProcessMonitoringStatus {
  aggregated: boolean
  workerCount: number
  workers: ProcessWorkerStatus[]
}

const useGetProcessStatus = (): [() => Promise<ProcessMonitoringStatus>, Status<ProcessMonitoringStatus>] => {
  const [request, requestStatus] = useFetchRefactored<ProcessMonitoringStatus>({
    errorMessage: 'Failed to fetch process monitoring status',
  })

  const getProcessStatus = useCallback(() => {
    return request({
      method: 'get',
      url: '/monitoring/processes',
    })
  }, [request])

  return [getProcessStatus, requestStatus]
}

export default useGetProcessStatus
